<template>
  <label class="st-checkbox" :class="{ 'st-checkbox--on-shell': onShell }">
    <input v-model="model" class="st-checkbox__input" type="checkbox" :disabled="disabled" />
    <span class="st-checkbox__box" aria-hidden="true">
      <font-awesome-icon v-if="model" icon="check" />
    </span>
    <span class="st-checkbox__label"><slot /></span>
  </label>
</template>

<script setup lang="ts">
const model = defineModel<boolean>({ default: false });
defineProps<{
  disabled?: boolean;
  onShell?: boolean;
}>();
</script>

<style scoped>
.st-checkbox {
  display: inline-flex;
  align-items: center;
  gap: var(--st-space-2);
  color: var(--st-text-muted);
  font-size: var(--st-text-sm);
  line-height: var(--st-leading-tight);
  cursor: pointer;
  user-select: none;
}
.st-checkbox__input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.st-checkbox__box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 1rem;
  height: 1rem;
  border: 1px solid var(--st-border-strong);
  border-radius: var(--st-radius-xs);
  background: var(--st-surface);
  color: var(--st-accent-text);
  font-size: var(--st-text-2xs);
  transition: var(--st-transition);
}
.st-checkbox:hover .st-checkbox__box {
  border-color: var(--st-graphite-300);
}
.st-checkbox__input:checked + .st-checkbox__box {
  border-color: var(--st-accent);
  background: var(--st-accent);
}
.st-checkbox__input:focus-visible + .st-checkbox__box {
  box-shadow: var(--st-focus-ring);
}
.st-checkbox__input:disabled + .st-checkbox__box,
.st-checkbox__input:disabled ~ .st-checkbox__label {
  opacity: 0.55;
  cursor: not-allowed;
}
.st-checkbox--on-shell {
  color: var(--st-shell-text-muted);
}
.st-checkbox--on-shell .st-checkbox__box {
  border-color: var(--st-shell-border);
  background: var(--st-shell-surface);
}
.st-checkbox--on-shell:hover .st-checkbox__box {
  border-color: var(--st-shell-border-strong);
}
.st-checkbox--on-shell .st-checkbox__input:checked + .st-checkbox__box {
  border-color: var(--st-accent-on-dark);
  background: var(--st-accent-on-dark);
  color: var(--st-shell-bg);
}
.st-checkbox--on-shell .st-checkbox__input:focus-visible + .st-checkbox__box {
  box-shadow: var(--st-focus-ring-on-dark);
}
</style>
